module.exports = __webpack_public_path__ + "static/media/country_kn.28ff8774.webp";